/* Coshi — parallax for the festival doorway.

   Writes two numbers, --mx and --my (each roughly -1..1), onto .cs-bg. The
   block-print wall and the three deity ghosts each multiply them by a different
   distance in their own transform, so the wall barely shifts while the nearest
   deity swings — depth from one pointer position and no per-layer JS.

   Custom properties feeding composited transforms only: no layout, no paint.
   The loop parks itself once the layers settle, and on touch it runs a slow
   idle drift instead so the depth still reads without a pointer. */
(function () {
  'use strict';

  function start() {
    var bg = document.querySelector('.cs-bg');
    if (!bg || bg.getAttribute('data-motion')) return;
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    } catch (e) {}
    bg.setAttribute('data-motion', '1');

    var cur = { x: 0, y: 0 }, aim = { x: 0, y: 0 };
    var raf = null, idle = 0, t = 0, last = 0;

    var fine = false;
    try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}

    function tick(now) {
      var dt = last ? Math.min((now - last) / 1000, 0.05) : 0.016;
      last = now;
      t += dt;

      if (!fine) {
        aim.x = Math.sin(t * 0.17) * 0.55;
        aim.y = Math.sin(t * 0.12 + 1.1) * 0.4;
      }

      var k = Math.min(dt * 2.4, 1);
      var dx = aim.x - cur.x, dy = aim.y - cur.y;
      cur.x += dx * k;
      cur.y += dy * k;
      bg.style.setProperty('--mx', cur.x.toFixed(4));
      bg.style.setProperty('--my', cur.y.toFixed(4));

      if (Math.abs(dx) + Math.abs(dy) < 0.0008 && fine) {
        if (++idle > 30) { raf = null; return; }
      } else { idle = 0; }
      raf = requestAnimationFrame(tick);
    }

    function wake() { if (!raf) { last = 0; raf = requestAnimationFrame(tick); } }

    if (fine) {
      window.addEventListener('pointermove', function (e) {
        aim.x = (e.clientX / window.innerWidth) * 2 - 1;
        aim.y = (e.clientY / window.innerHeight) * 2 - 1;
        wake();
      }, { passive: true });
      window.addEventListener('pointerleave', function () { aim.x = 0; aim.y = 0; wake(); });
    }

    /* scrolling drifts the field vertically as well, so the wall and the
       deities separate on the way down the page */
    var maxScroll = 1;
    function measure() { maxScroll = Math.max(1, document.body.scrollHeight - window.innerHeight); }
    window.addEventListener('scroll', function () {
      var p = Math.min(1, Math.max(0, window.scrollY / maxScroll));
      aim.y = (fine ? aim.y : aim.y) * 0.5 + (p * 2 - 1) * 0.5;
      wake();
    }, { passive: true });

    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { measure(); wake(); }, 180);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { if (raf) { cancelAnimationFrame(raf); raf = null; } }
      else wake();
    });

    measure();
    window.addEventListener('load', measure);
    wake();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else { start(); }
})();
